import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import MyOrders from "../../components/my-orders";
import AuthGuard from "../../components/route-guard/AuthGuard";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = () => {
    const { configData, landingPageData, loading } = useConfigData();
    const router = useRouter();

    return (
        <>
            {loading ? (
                <SplashScreen />
            ) : (
                <>
                    <SEO
                        title={configData ? `My Orders` : "Loading..."}
                        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
                        businessName={configData?.business_name}
                    />

                    <CssBaseline/>
                    <AuthGuard from={router.pathname.replace("/", "")}>
                        <MainLayout configData={configData} landingPageData={landingPageData}>
                            <MyOrders configData={configData}/>
                        </MainLayout>
                    </AuthGuard>
                </>
            )}
        </>
    );
};

export default Index;
